import React, { useState } from "react";
import logo from "./res/ajorist-wt.png";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { href: "/journal", text: "Home" },
    { href: "/journal#about", text: "About" },
    { href: "/journal#editorial", text: "Editorial Board" },
    { href: "/journal#footer", text: "Contact" },
  ];

  return (
    <header className="bg-sky-900/95 backdrop-blur-sm sticky top-0 z-50 shadow-md shadow-sky-900/10">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <a href="/journal" className="flex-shrink-0">
              <img className="h-10" src={logo} alt="AJORIST Logo" />
            </a>
          </div>
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sky-100 hover:bg-sky-800/60 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors"
              >
                {link.text}
              </a>
            ))}
            <a
              href="/journal/latest"
              className="ml-2 bg-sky-500 text-white font-semibold px-4 py-2 rounded-lg shadow-sm hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-opacity-75 transition-all text-sm"
            >
              Latest Issue
            </a>
          </div>
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="bg-sky-800/50 inline-flex items-center justify-center p-2 rounded-md text-sky-200 hover:text-white hover:bg-sky-800/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-sky-900 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`h-6 w-6 transform transition-transform ${
                  isOpen ? "rotate-180" : ""
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu, show/hide based on menu state. */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        } overflow-hidden`}
        id="mobile-menu"
      >
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 border-t border-sky-800/50">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sky-100 hover:bg-sky-800/60 hover:text-white block px-3 py-2 rounded-md text-base font-medium transition-colors"
            >
              {link.text}
            </a>
          ))}
          <div className="pt-2">
            <a
              href="/journal/latest"
              className="block w-full text-center bg-sky-500 text-white font-semibold px-4 py-2 rounded-lg shadow-sm hover:bg-sky-600 transition-all text-base"
            >
              Latest Issue
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
